import { FontFamily } from '../../../../../constants/fonts';

// Card look from the mockup (wes_pallet_staging_analytics_v7.html): white, radius 8, soft blue shadow, padding 20.
export const WES_CARD = {
  backgroundColor: '#FFFFFF',
  borderRadius: 8,
  padding: 20,
  shadowColor: '#005EC0',
  shadowOpacity: 0.08,
  shadowRadius: 24,
  shadowOffset: { width: 0, height: 0 },
  elevation: 1,
} as const;

export const WES_CARD_TITLE = { fontSize: 16, fontFamily: FontFamily.bold, color: '#2D2D2D' } as const;
export const WES_CARD_TITLE_SUFFIX = { fontFamily: FontFamily.medium, color: '#838383' } as const;
export const WES_CARD_SUBTITLE = { fontSize: 12, fontFamily: FontFamily.regular, color: '#838383', marginTop: 2, marginBottom: 14 } as const;
